export default __webpack_public_path__ + "static/media/card-blog2.d5eda64e.jpg";